module.exports = __webpack_public_path__ + "static/media/our_platform_is_omnichannel_bg.036ac565.png";